import { render, staticRenderFns } from "./interface-guide-page.vue?vue&type=template&id=f256f32e&scoped=true&"
import script from "./interface-guide-page.vue?vue&type=script&lang=js&"
export * from "./interface-guide-page.vue?vue&type=script&lang=js&"
import style0 from "./interface-guide-page.vue?vue&type=style&index=0&id=f256f32e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/172.26.59.72+4873+vue-loader@15.10.1_efzthsey6ubluzya6o5i357ujq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f256f32e",
  null
  
)

export default component.exports